import angular from 'angular';

import ProductsStoreFactory from './products.store.factory';
import MenuStoreFactory from './menu.store.factory';

const storesModule = angular.module('tinaba.common.stores', [])

.factory('ProductsStore', ProductsStoreFactory)

.factory('MenuStore', MenuStoreFactory);

export default storesModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/stores/stores.js
 **/